import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const SearchVideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.bgColor};
  overflow-y: auto;
  padding: 20px;
  @media screen and (min-width: 768px) {
    padding: 30px;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  max-width: 250px;
  border: 1px solid ${props =>
    props.isDarkTheme ? '#fff' : '#64748b'}; // Adjust border color
  border-radius: 4px;
  padding: 10px;
  margin: 10px 0;
  font-size: 16px;
  background-color: ${props =>
    props.isDarkTheme ? '#181818' : '#f9f9f9'}; // Background color
  color: ${props => (props.isDarkTheme ? '#fff' : '#000')}; // Text color
`

export const SearchButton = styled.button`
  background-color: transparent; // Make it transparent to blend with the input
  border: 1px solid ${props =>
    props.isDarkTheme ? '#fff' : '#64748b'}; // Adjust border color
  color: ${props => (props.isDarkTheme ? '#fff' : '#000')}; // Text color
  cursor: pointer;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${props =>
      props.isDarkTheme ? '#fff' : '#181818'}; // Change on hover
    color: ${props =>
      props.isDarkTheme ? '#000' : '#fff'}; // Change text color on hover
  }
`
export const ProductsLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  @media screen and (min-width: 768px) {
    width: 70%;
  }
`

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  align-items: center;
  background-color: #fff;
`

export const Image = styled.img`
  width: 300px;
  margin: 20px;
`

export const Heading = styled.h1`
  color: black;
  text-align: center;
  font-size: 30px;
`

export const Desc = styled.p`
  color: black;
  text-align: center;
  font-size: 20px;
`

export const NavLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1e293b;
  text-decoration: none;
  margin-bottom: 32px;
`

export const Retry = styled.button`
  padding: 15px;
  color: blue;
  cursor: pointer;
`

export const VideosContainer = styled.ul`
  display: flex;
  flex-wrap: wrap; /* Enable wrapping */
  list-style-type: none;
  padding: 0;
  justify-content: space-around; /* Add space between items */

  & > li {
    flex-basis: calc(33.33% - 20px); /* Calculate width for 3 cards in a row, minus some margin */
    margin-bottom: 20px; /* Space between rows */
  }

  @media screen and (max-width: 768px) {
    & > li {
      flex-basis: calc(50% - 10px); /* Adjust for 2 cards per row on medium screens */
    }
  }

  @media screen and (max-width: 480px) {
    & > li {
      flex-basis: 100%; /* Full width for small screens */
    }
  }
`
